export const ROUTE_NAMES = {
  IFRAME: 'reports-iframe'
}

const ROUTES = {
  [ROUTE_NAMES.IFRAME]: {
    name: ROUTE_NAMES.IFRAME,
    path: 'reports'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.IFRAME].name,
    path: ROUTES[ROUTE_NAMES.IFRAME].path,
    component: (resolve) => require(['./views/iframe'], resolve)
  }
]
